module.exports = __webpack_public_path__ + "img/aktuelle-pelletspreise.623bfb1.webp";